var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HotPage"},[(_vm.sonInfo)?_c('Hot',{attrs:{"info":_vm.sonInfo,"hotIdOrName":_vm.hotIdOrName,"isOne":true},on:{"hotClose":() => {}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }